/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { Currency } from './';
import {
    CurrencyFromJSON,
    CurrencyFromJSONTyped,
    CurrencyToJSON,
} from './';
import type { DeliverablePaymentStatus } from './';
import {
    DeliverablePaymentStatusFromJSON,
    DeliverablePaymentStatusFromJSONTyped,
    DeliverablePaymentStatusToJSON,
} from './';
import type { ProjectDeliverablePaymentResource } from './';
import {
    ProjectDeliverablePaymentResourceFromJSON,
    ProjectDeliverablePaymentResourceFromJSONTyped,
    ProjectDeliverablePaymentResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface AwaitingClientPaymentResource
 */
export interface AwaitingClientPaymentResource extends ProjectDeliverablePaymentResource {
    /**
     * 
     * @type {Date}
     * @memberof AwaitingClientPaymentResource
     */
    expectedPaymentDate: Date;
    /**
     * 
     * @type {number}
     * @memberof AwaitingClientPaymentResource
     */
    paymentDelay: number;
}

/**
 * Check if a given object implements the AwaitingClientPaymentResource interface.
 */
export function instanceOfAwaitingClientPaymentResource(value: object): value is AwaitingClientPaymentResource {
    if (!('expectedPaymentDate' in value) || value['expectedPaymentDate'] === undefined) return false;
    if (!('paymentDelay' in value) || value['paymentDelay'] === undefined) return false;
    return true;
}

export function AwaitingClientPaymentResourceFromJSON(json: any): AwaitingClientPaymentResource {
    return AwaitingClientPaymentResourceFromJSONTyped(json, false);
}

export function AwaitingClientPaymentResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): AwaitingClientPaymentResource {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...ProjectDeliverablePaymentResourceFromJSONTyped(json, ignoreDiscriminator),
        'expectedPaymentDate': (new Date(json['expectedPaymentDate'])),
        'paymentDelay': json['paymentDelay'],
    };
}

export function AwaitingClientPaymentResourceToJSON(value?: AwaitingClientPaymentResource | null, ignoreDiscriminator?: boolean): any {
    if (value == null) {
        return value;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...ProjectDeliverablePaymentResourceToJSON(value, true),
        'expectedPaymentDate': ((value['expectedPaymentDate']).toISOString().substring(0,10)),
        'paymentDelay': value['paymentDelay'],
    };
}

